import { BUTTON_MODES } from '../model'

const status = (base, channel) => base | (channel === 'omni' || !channel ? 0 : channel - 1)

/** @returns {number[][] | null} the messages, or null when the source has nothing to show */
export const feedbackMessages = (binding, pos) => {
	const { type, number: n = 0, channel } = binding.source
	const button = type === 'note' || BUTTON_MODES.has(binding.mode)
	const x = button ? (pos >= 0.5 ? 1 : 0) : Math.min(1, Math.max(0, pos))
	const v7 = Math.round(x * 127)
	const v14 = Math.round(x * 16383)
	const cc = status(0xb0, channel)
	switch (type) {
		case 'cc':
			return [[cc, n, v7]]
		case 'cc14':
			return [
				[cc, n, v14 >> 7],
				[cc, n + 32, v14 & 127],
			]
		case 'nrpn':
			return [
				[cc, 99, n >> 7],
				[cc, 98, n & 127],
				[cc, 6, v14 >> 7],
				[cc, 38, v14 & 127],
			]
		case 'note':
			// Note-on velocity 0 is the off every LED pad honours.
			return [[status(0x90, channel), n, v7]]
		case 'pitchbend':
			return [[status(0xe0, channel), v14 & 127, v14 >> 7]]
		default:
			return null
	}
}
